"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5985 2v1.0526c0 1.3655-.5335 2.0844-1.1918 2.9714-.6421.8652-1.2727 1.7751-1.2778 2.9448-.004.9469.3702 1.9178 1.0899 2.9972L11.3186 22h1.3918l3.0251-9.9979c.9891-1.2838 1.4362-2.5977 1.3901-3.8837C16.9772 3.9824 12.87 2 9.5985 2zm3.945 10.5263h-3.1139l1.5732 5.0923 1.5407-5.0923zm-3.7166-5.058c.5486-.7218 1.3101-1.7238 1.592-3.2108 1.6428.5017 3.7039 1.903 3.7771 3.9432.0216.601-.156 1.3449-.7717 2.2204H9.5856c-.4324-.7177-.5268-1.1648-.5256-1.4425.0026-.5886.4406-1.081.7669-1.5103z"
  })];
};

exports.default = _default;